import React from 'react';
import SelectField from 'material-ui/SelectField';

export default props =>
  <SelectField
    {...props.inputProps}
    {...props.input}
    errorText={props.meta.touched && props.meta.error && props.meta.error}
    onChange={(event, index, value) => props.input.onChange(value)}
  >
    {props.children}
  </SelectField>;



// WEBPACK FOOTER //
// src/modules/forms/components/SelectField.js